export default __webpack_public_path__ + "static/media/high heels_ar 1.b56f49cc.png";